<div class="container flex flex-col md:pt-[12px] mt-[230px] sm:mt-4 mb-4 gap-9">
    <ng-container *ngIf="SuggestedTypes | async as items;else loadingType">
        <div class="border border-solid border-neutral-200 px-6 rounded-xl lg:w-4/5 mx-auto py-5">
            <div class="gap-5 flex items-center justify-evenly flex-wrap">
                <div *ngFor="let item of items ; let index = index"
                    class="bg-white rounded-2xl flex flex-col items-center justify-center py-2 md-min-w-auto min-w-[88px] hover:bg-slate-50 cursor-pointer duration-300 transition-all">
                    <a [href]="item.Link" class="w-full flex flex-col items-center justify-center ">
                        <img [src]=" '/assets/images/specialTypes/' + item.Icon + '.svg'">
                        <span class="mt-2 text-base text-neutral-600 text-center !font-medium">
                            {{item.Title}}
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="allSections$ | async as vm;else loading">
            <div *ngFor="let sectionData of vm; let i = index">
                <div [ngSwitch]="sectionData?.Section?.ViewName" class="flex flex-col container lg:px-0">
                    <ng-container class="main-section-wrapper" *ngComponentOutlet="
                        sectionData?.Section?.ViewName | getFlexSection;
                        inputs: { dataSource: sectionData }
                       "></ng-container>
                </div>
            </div>
            <div class="main-section-wrapper container mt-6">
                <iho-about-iho-special />
                <iho-ecolodge-faq-special />
            </div>
        
        </ng-container>
        <ng-template #loadingType>
            <iho-ecolodge-types-skeleton />
        </ng-template>
        <ng-template #loading>
            <div class="container flex flex-col pt-44 md:pt-[12px] mt-16 lg:mt-4 mb-4 gap-6">
             
                <iho-banners-skeleton />
                <iho-slider-bg-text-skeleton />
            </div>
            </ng-template>
   

</div>